import firebase from "firebase/app";
import "firebase/firestore";
import _ from "lodash";
import { makeDRAFT } from "src/util/types";
import { tAdminConnection, tRepCategory } from "tmt_api/src/types/types.validator";
import { tApplicationState_DRAFT, tDefaultApplication } from "./types";

const kDraftBrand: tDefaultApplication["brand"] = makeDRAFT({
  type: "brand",
  name: "",
  address: {
    address1: "",
    city: "",
    country_code: "US",
    first_name: "",
    last_name: "",
    postal_code: "",
    state_or_province: "",
  },
  taxId: "",
  website: "",
  socialMedia: {
    facebook: "",
    instagram: "",
  },
  category: "Accessories",
  price: "$",
  independentRetailerQuantity: "none",
  isBasedInUs: false,
  canConductBusinessInUs: false,
  independentRetailersInUs: false,
  note: "",
  contact: { email: "", firstName: "", lastName: "", phone: "" },
  isShown: false,
  emailDisabled: false,
  hearAboutUsDisabled: false,
  applicationSent: false,
} as const);
const kDraftRep: tDefaultApplication["rep"] = makeDRAFT({
  type: "rep",
  companyName: "",
  address: {
    address1: "",
    city: "",
    country_code: "US",
    first_name: "",
    last_name: "",
    postal_code: "",
    state_or_province: "",
  },
  taxId: "",
  website: "",
  socialMedia: {
    facebook: "",
    instagram: "",
  },
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  category: [] as tRepCategory[],
  agency: false,
  brandQuantity: "1-5",
  price: "$",
  note: "",
  contact: { email: "", firstName: "", lastName: "", phone: "" },
  isShown: false,
  emailDisabled: false,
  hearAboutUsDisabled: false,
  applicationSent: false,
} as const);
const kDraftRetailer: tDefaultApplication["retailer"] = makeDRAFT({
  type: "retailer",
  name: "",
  address: {
    address1: "",
    city: "",
    country_code: "US",
    first_name: "",
    last_name: "",
    postal_code: "",
    state_or_province: "",
  },
  taxId: "",
  website: "",
  socialMedia: {
    facebook: "",
    instagram: "",
  },
  category: "Apothecary",
  price: "$",
  locationQuantity: "0-1",
  ecommerceLink: "",
  note: "",
  contact: { email: "", firstName: "", lastName: "", phone: "" },
  isShown: false,
  emailDisabled: false,
  hearAboutUsDisabled: false,
  applicationSent: false,
} as const);
const kDefaultApplication: tDefaultApplication = {
  brand: kDraftBrand,
  rep: kDraftRep,
  retailer: kDraftRetailer,
  tmtAdmin: kDraftBrand,
  none: kDraftBrand,
} as const;

export const getDefaultApplication = (myType: keyof typeof kDefaultApplication): tApplicationState_DRAFT => {
  return _.cloneDeep(kDefaultApplication[myType]);
};

const kDefaultAdminApplicationData: tAdminConnection = {
  application: {
    address: {
      address1: "",
      city: "",
      country_code: "",
      first_name: "",
      last_name: "",
      postal_code: "",
      state_or_province: "",
    },
    contact: {
      email: "",
      firstName: "",
      lastName: "",
      phone: "",
    },
    category: "Accessories",
    independentRetailerQuantity: "none",
    name: "",
    note: "",
    price: "$",
    type: "brand",
    website: "",
  },
  startDate: firebase.firestore.Timestamp.now(),
  status: "Request",
  type: "Admin",
  uuid: "",
};

export const getDefaultAdminApplication = (): tAdminConnection => _.cloneDeep(kDefaultAdminApplicationData);
